import React from "react";
import { TableCell, TableRow, TableHead } from "@material-ui/core";
import * as ReactBootstrap from "react-bootstrap";
import RepairUploadMediaRow from "./RepairUploadMediaRow";
import classes from "./styles.module.css";

interface MediaFile {
  name: string;
  size: number;
  fileType: string;
}

interface MediaFilesTableProps {
  mediaFiles: MediaFile[];
  deleteMediaFile: (id: number) => void;
  props: any;
}

const MediaFilesTable: React.FC<MediaFilesTableProps> = ({
  mediaFiles,
  deleteMediaFile,
  props,
}) => {
  if (mediaFiles.length < 1) {
    return null;
  }

  return (
    <div className="mb-4 mt-4 text-black">
      <div className="w-full border border-grey">
        <ReactBootstrap.Table striped className="container-new">
          <TableHead className={classes.tableRowColor}>
            <TableRow>
              <TableCell className="items-center">
                <strong className={classes.tableHeader}>Name</strong>
              </TableCell>

              <TableCell align="right" className="items-center">
                <strong className={classes.tableHeader}>Remove</strong>
              </TableCell>
            </TableRow>
          </TableHead>
        </ReactBootstrap.Table>

        {mediaFiles.map((mediaFile: any, key: number) => {
          return (
            <RepairUploadMediaRow
              key={`${mediaFile.name}-${mediaFile.fileType}-${key}`}
              mediaFileName={mediaFile.name}
              type={mediaFile.fileType}
              bgColour={"bg-white"}
              deleteMediaFile={() => deleteMediaFile(key)}
              {...props}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MediaFilesTable;
